module.exports = __webpack_public_path__ + "img/JSB_FINANCING2.149a4550.png";